import React from 'react';
import { TIconProps } from '../types';

function PlayIcon({ fill = 'currentColor', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <path
        d="M6.5 4.5L11.5 8L6.5 11.5V4.5Z"
        fill={fill}
      />
    </svg>
  );
}

export default PlayIcon;
